module.exports = __webpack_public_path__ + "img/cogwheel.png";